<script setup lang="ts">
import { computed } from 'vue'
import { useUserProfile } from '@/features/user/composables/useUserProfile'

const { isImpersonated, loading } = useUserProfile()

// Gate on !loading so a stale persisted profile can't flash the banner during
// the initial profile fetch (useAppBootstrap sets loading=true synchronously).
const visible = computed(() => isImpersonated.value && !loading.value)
</script>

<template>
	<Transition name="slide-down">
		<v-alert
			v-if="visible"
			type="error"
			variant="tonal"
			rounded="0"
			density="compact"
			class="impersonation-banner px-6 py-2"
		>
			<i class="fa-solid fa-user-secret mr-2" />
			<span class="font-weight-bold">
				Be careful. You are currently impersonating someone else's account.
			</span>
		</v-alert>
	</Transition>
</template>

<style scoped lang="scss">
.impersonation-banner {
	border-radius: 0 !important;
	border-left: none !important;
	border-right: none !important;
	border-top: none !important;
}
</style>
